import React from "react";
import Questionnaire from "components/Questionnaire/questionnaire";
import styles from "./SearchPage.module.css";
import default_theme from "assets/themes/themes";

const SearchPage = () => {
  return (
    <div 
      className={styles.mainContainer}
      style={{
        flex: 1, 
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: default_theme.palette.other.white, 
        minHeight: '100%',
      }}
    >
      <Questionnaire />
    </div>
  );
};

export default SearchPage;